export function notUndefined<A>(x?: A): x is A {
  return x !== undefined;
}
